<div
  *ngIf="couchSync.isGlobalLoading$ | async"
  class="fixed inset-0 z-9999 flex flex-col items-center justify-center bg-base-100/80 backdrop-blur-md transition-all duration-300"
>
  <div
    class="flex flex-col items-center gap-4 p-6 bg-base-200 rounded-box shadow-2xl border border-base-300"
  >
    <span class="loading loading-spinner loading-lg text-primary"></span>

    <div class="text-center">
      <h3 class="font-bold text-lg text-base-content">Mise à jour de l'application</h3>
      <p class="text-sm text-base-content/70">Synchronisation de vos bases de données...</p>
    </div>
  </div>
</div>

<div *ngIf="!auth.currentUser || !(couchSync.isGlobalLoading$ | async)">
  <router-outlet></router-outlet>
</div>
